// extracted by mini-css-extract-plugin
module.exports = {"container":"Socials_container__3OrLl"};